import { Expose } from "class-transformer";

export class UpdateClientGroupDto {
  @Expose()
  name: string;

  @Expose()
  clientTypeId?: string;
}
